const colors = {
  pink: "#FF1493",
  darkPink: "#990C58",
  black: "#14020C",
  gray: "#252123",
  white: "#FFF9FC",
};

export default colors;
